import { literalUnion } from "diagnostics-lib/io";
import createGlobalState from "@ui/lib/createGlobalState";
import * as io from "io-ts";

export const COLUMNS = [
  "name",
  "projectName",
  "projectType",
  "projectSite",
  "description",
  "system",
  "equipmentType",
  "unit",
  "nature",
  "value",
  "tagDataSource",
] as const;

export type Column = (typeof COLUMNS)[number];

const DEFAULT_VISIBLE_COLUMNS: Column[] = [
  "name",
  "projectName",
  "projectType",
  "projectSite",
  "description",
  "system",
  "equipmentType",
  "unit",
  "tagDataSource",
];

export const requiredVisibleColumns: Column[] = ["name"];

export const useColumns = createGlobalState({
  storage: "session",
  key: "administrationQuantityColumns",
  type: io.array(literalUnion(COLUMNS)),
  defaultValue: DEFAULT_VISIBLE_COLUMNS,
  scoped: false,
});
